(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function ready(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    function num(el) {
      var v = parseFloat((el.value || '').replace(',', '.'));
      return isNaN(v) ? 0 : v;
    }

    function fmt(m) {
      return (Math.ceil(m * 10) / 10).toFixed(1).replace('.', ',');
    }

    ready(function () {
      // Perde (curtain) calculators
      document.querySelectorAll('.km-calc[data-km-calc="perde"]').forEach(function (box) {
        var out = box.querySelector('.km-calc-out');
        function calc() {
          var W = num(box.querySelector('[name=genislik]'));
          var H = num(box.querySelector('[name=boy]'));
          var P = parseFloat(box.querySelector('[name=pile]').value);
          var EN = parseFloat(box.querySelector('[name=en]').value);
          if (!W || !H) { out.textContent = 'Ölçüleri girin.'; return; }
          var kanat = Math.max(1, Math.ceil((W * P) / EN));
          var drop = H + 30; // üst tünel + alt baskı payı
          var m = (kanat * drop) / 100;
          out.innerHTML = '≈ <strong>' + fmt(m) + ' m</strong> kumaş<span>' +
            kanat + ' kanat · ' + EN + ' cm en · ×' + String(P).replace('.', ',') + ' pile</span>';
        }
        box.addEventListener('input', calc);
        box.addEventListener('change', calc);
        calc();
      });

      // Döşemelik (upholstery) calculators
      document.querySelectorAll('.km-calc[data-km-calc="doseme"]').forEach(function (box) {
        var out = box.querySelector('.km-calc-out');
        function calc() {
          var PW = num(box.querySelector('[name=parcaEn]'));
          var PL = num(box.querySelector('[name=parcaBoy]'));
          var AD = num(box.querySelector('[name=adet]')) || 1;
          var EN = parseFloat(box.querySelector('[name=en]').value);
          if (!PW || !PL) { out.textContent = 'Ölçüleri girin.'; return; }
          var perRow = Math.max(1, Math.floor(EN / PW)); // yan yana sığan parça
          var rows = Math.ceil(AD / perRow);
          var m = (rows * PL) / 100 * 1.15; // %15 fire
          out.innerHTML = '≈ <strong>' + fmt(m) + ' m</strong> kumaş<span>' +
            AD + ' parça · ' + EN + ' cm en · %15 fire dahil</span>';
        }
        box.addEventListener('input', calc);
        box.addEventListener('change', calc);
        calc();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('pointerover', function (e) {
    var leftItem = e.target.closest('.mood-menu__left-item');
    if (!leftItem) return;
    var moodMenu = leftItem.closest('.mood-menu');
    if (!moodMenu) return;

    var leftItems = Array.from(moodMenu.querySelectorAll('.mood-menu__left > .mood-menu__left-item'));
    var index = leftItems.indexOf(leftItem);
    if (index === -1) return;

    moodMenu.querySelectorAll('.mood-menu__left-item--last-hovered').forEach(function (el) {
      el.classList.remove('mood-menu__left-item--last-hovered');
    });
    moodMenu.querySelectorAll('.mood-menu__right-group--last-shown').forEach(function (el) {
      el.classList.remove('mood-menu__right-group--last-shown');
    });

    leftItem.classList.add('mood-menu__left-item--last-hovered');
    var rightGroups = Array.from(moodMenu.querySelectorAll('.mood-menu__right > .mood-menu__right-group'));
    if (rightGroups[index]) {
      rightGroups[index].classList.add('mood-menu__right-group--last-shown');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
